import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/svg/burger-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-49a7099f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left-col" }
const _hoisted_2 = { class: "picture" }
const _hoisted_3 = {
  key: 0,
  class: "desktop-menu"
}
const _hoisted_4 = { class: "menu-el" }
const _hoisted_5 = { class: "menu-el" }
const _hoisted_6 = { class: "menu-el" }
const _hoisted_7 = { class: "right-col" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "burger icon"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["header", {animation:_ctx.playPreview}]),
    ref: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "logo"
      }, {
        default: _withCtx(() => [
          _createElementVNode("picture", _hoisted_2, [
            _createVNode(_component_AppLogo)
          ])
        ]),
        _: 1
      }),
      (_ctx.isDesktop)
        ? (_openBlock(), _createElementBlock("menu", _hoisted_3, [
            _createElementVNode("li", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/web",
                class: "menu-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Websites")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: "/applications",
                class: "menu-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Applications")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: "/design",
                class: "menu-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Design")
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.isDesktop)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            target: "_blank",
            href: _ctx.commonData['commonContactUs'],
            class: "btn contact-btn"
          }, "Contact us", 8, _hoisted_8))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn burger-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('mobileMenu', true)))
          }, _hoisted_10))
    ])
  ], 2))
}